import { useTranslation } from "react-i18next"

interface UsageDisplayProps {
  accumulatedCount: number
  quota: number
  percent: number
  isFreeTierUser: boolean
  variant?: "default" | "dialog"
}

const UsageDisplay = ({
  accumulatedCount,
  quota,
  percent,
  isFreeTierUser = false,
  variant = "default",
}: UsageDisplayProps) => {
  const { t } = useTranslation()

  const isDialog = variant === "dialog"

  const usageText = <p className="text-gray-color">{t("mt.wordsUsed")}</p>

  const usageCount = (
    <section className="flex items-center space-x-2">
      <p className="font-medium">{Number(accumulatedCount).toLocaleString()}</p>
      <p className="text-gray-color">/</p>
      <p className="text-gray-color">{quota.toLocaleString()}</p>
    </section>
  )

  const getProgressColor = () => {
    if (percent >= 100) return "bg-danger"
    if (percent >= 80) return "bg-warning"
    return "bg-secondary"
  }

  const progressBar = (
    <section
      className={`relative overflow-hidden rounded-default bg-gray-color-2 ${
        isDialog ? "h-5 w-full" : "h-[5px] w-32"
      }`}
      aria-label={t("mt.wordsUsed")}
    >
      <span
        className={`absolute left-0 top-0 h-full ${getProgressColor()}`}
        style={{
          width: `${percent}%`,
          transition: "width 0.3s",
        }}
      />
    </section>
  )

  if (isDialog) {
    return (
      <section className="flex flex-col space-y-2 text-sm">
        <section className="flex items-center justify-between">
          {usageText}
          <section className="flex items-center space-x-2">
            {usageCount}
            {percent >= 100 && !isFreeTierUser && (
              <p className="rounded-default bg-gray-color-2 px-1.5">
                {t("mt.willBeCharged")}
              </p>
            )}
          </section>
        </section>
        {progressBar}
      </section>
    )
  }

  return (
    <section className="flex items-center space-x-2">
      {usageText}
      {usageCount}
      {progressBar}
    </section>
  )
}

export default UsageDisplay
